import React, { useState, useEffect } from 'react';
import Unit from '../../../../../forms/unit';
import restApiClient from '../../../../../services/restApiClient';
import CrudTable from '../../../../../components/crudTable';
import FilterTree from '../../../../../helpers/filterTree';
import { Container, AddChart } from './styles';
import StockConsumption from '../../../../../forms/stockConsumption';
import moment from 'moment';

function StockConsumptionList({ history }) {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderby] = useState({ name: 'asc' });
  const [searchBy, setSearchBy] = useState('');

  const columns = Unit.tableSchema;

  useEffect(() => {
    restApiClient.unit
      .getAllWithConsumptions(
        rowsPerPage,
        page * rowsPerPage,
        searchBy
          ? new FilterTree()
              .and((leftChild, rightChild) => {
                leftChild.df('type', 'distribution_center');
                rightChild.like('name', searchBy);
              })
              .toString()
          : new FilterTree().df('type', 'distribution_center').toString(),
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  return (
    <Container>
      <CrudTable
        title={'Consumo do Estoque'}
        modelActions={Unit.actions}
        columns={columns}
        customColumns={[
          {
            id: 'lastStockConsumption',
            label: 'Último Envio',
            minWidth: 50,
            align: 'center',
          },
        ]}
        rows={rows}
        page={page}
        setPage={(page) => setPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
        onOrderByChange={(orderBy) => setOrderby(orderBy)}
        orderBy={orderBy}
        setOrderBy={(value) => setOrderby(value)}
        searchBy={searchBy}
        setSearchBy={(value) => setSearchBy(value)}
        actions={{
          throwComsumption: {
            title: 'Lançar Consumo',
            icon: <AddChart />,
            onClick: (id, row) => {
              history.push({
                pathname: `/administrative/stock-consumption/unit/${id}`,
                state: { labelUnit: row?.name },
              });
            },
            allowedActions: [StockConsumption.actions.getAllByUnit],
          },
        }}
        customCellRenderers={{
          lastStockConsumption: {
            renderer: (field, value, column, row) => {
              if (row?.lastStockConsumption) {
                return `${moment(row.lastStockConsumption.endDate).format(
                  'DD/MM/YYYY'
                )}`;
              } else {
                return '-';
              }
            },
          },
        }}
      />
    </Container>
  );
}

export default StockConsumptionList;
